module.exports = __webpack_public_path__ + "img/brandme_ia_white.850932c6.svg";